import React, {Component} from 'react';
import { Container } from 'react-bootstrap';
import {
  UPDATE_DASHBOARD_WIDGET_INSTANCE, GET_DASHBOARD_WIDGET_TYPES, CREATE_DASHBOARD_WIDGET_INSTANCE,
  UPDATE_DASHBOARD, DELETE_DASHBOARD_WIDGET_INSTANCE} from '../queries';
import DashboardWidget from './DashboardWidget';
//import VoiceControl from './VoiceControl';
import Navigation from './Navigation';
//import Footer from './Footer';
import {withApollo, WithApolloClient} from 'react-apollo';
import { withToastManager } from 'react-toast-notifications'
import assign from 'lodash/assign';
import remove from 'lodash/remove';
import {transform} from 'ol/proj.js';

import moment from 'moment';

import ModalAddWidget from './modals/ModalAddWidget';
import ModalDeleteWidget from './modals/ModalDeleteWidget';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import Sidebar from './Sidebar';

import { SocketComp } from '../context/socket';

var GridLayout = require("react-grid-layout");
const uuidv4 = require('uuid/v4');
let gridRef:any = null;

interface IDashboardProps {
  dashboardData: any,
    refetchDashboard: Function
}

interface IDashboardState {
  dashboard: any,
    widgetTypes: any,
    layout: any,
    newCounter: number,
    cols: number,
    showAddWidgetModal: boolean,
    showWidgetDeleteModal: boolean,
    selectedWidget: any,
    map: any,
    layerList: any,
    pageLoaded: boolean,
    //gridRef:any,
}

interface WidgetType {
    id: number,
    name: string,
    description: string,
    base_width: number,
    base_height: number
}

class Dashboard extends Component<WithApolloClient<any>, IDashboardState> {
  constructor(props: any) {
    super(props);

    this.onDashboardLoad = this.onDashboardLoad.bind(this);
    this.onSaveDashboard = this.onSaveDashboard.bind(this);
    this.onLayoutChange = this.onLayoutChange.bind(this);
    this.onAddWidget = this.onAddWidget.bind(this);
    this.onHandleCloseAddWidgetModal = this.onHandleCloseAddWidgetModal.bind(this);
    this.onHandleCloseDeleteWidgetModal = this.onHandleCloseDeleteWidgetModal.bind(this);
    this.onHandleAddWidget = this.onHandleAddWidget.bind(this);
    this.onHandleDeleteWidget = this.onHandleDeleteWidget.bind(this);
    this.onShowWidgetOptions = this.onShowWidgetOptions.bind(this);
    this.reloadDashboard = this.reloadDashboard.bind(this);
    this.onConfigUpdate = this.onConfigUpdate.bind(this);
    this.updateWidgetInstances = this.updateWidgetInstances.bind(this);

    this.state = {
      dashboard: null,
      widgetTypes: null,
      layout: null,
      newCounter: 0,
      cols: 12,
      showAddWidgetModal: false,
      showWidgetDeleteModal: false,
      selectedWidget: null,
      map:[],
      layerList: null,
      pageLoaded: false,
      //gridRef: null,
    };
  }

  

  componentDidMount() {
    const { dashboardData } = this.props;
    this.onDashboardLoad(dashboardData);
    this.loadWidgetData();
  }

  onLayoutChange(layout: any) {
    console.log("120321 layout",layout)
    //layout[0].minW = 20;
    //layout[0].minH = 20;
    /* could add this as class
      width: calc(100vw - 100px);
      height: calc(100vh - 125px);
      z-index: 10;
    */
    this.setState({layout});
  }

  loadWidgetData() {
    const { client } = this.props;
    client.query({
      query: GET_DASHBOARD_WIDGET_TYPES,
      optimisticResponse: null
    }).then((widgetTypeData:any) => {
      const widgetTypes = widgetTypeData.data.syncarto_app_dashboard_widget_type;
      this.setState({
        widgetTypes
      });
    });
  }

  onShowWidgetOptions(widgetInstance:any, type:string = "edit") {
    console.log("Showing options for ", widgetInstance);
    switch(type) {
      case "delete":
        this.setState({showWidgetDeleteModal: true, selectedWidget: widgetInstance});
        break;
      default:
        switch(widgetInstance.dashboard_widget_type_id) {

        }
        break;
    }
  }

  renderWidgetInstances(dashboardWidgetInstances:any, widgetTypes: any) {
    // Only create a map widget if the empty dashboard is being loade
    console.log("120321 RENDER dashboardWidgetInstances, widgetTypes", dashboardWidgetInstances, widgetTypes)
    if ((dashboardWidgetInstances.length === 0) && !this.state.pageLoaded){
      this.setState({pageLoaded: true});
      dashboardWidgetInstances.push({
        "id": uuidv4(), //e.g., "8b878b43-76bc-4ff8-aa24-78a946dcebf2",
        "dashboard_id": this.props.dashboardData.id, //e.g., "d90acc8a-2778-4010-8634-3bf43b531b74"
        "dashboard_widget_type_id":1,
        "title":"Map",
        "location_x":0,
        "location_y":0,
        "width":6,
        "height":12,
        "minW": 0,
        "minH": 0,
        "needsCreate":true
      })
    }
    return dashboardWidgetInstances.map((widgetInstance:any) => {
      let gridData = {
        x: widgetInstance.location_x,
        y: widgetInstance.location_y,
        w: widgetInstance.width || 3,
        h: widgetInstance.height || 3,
        minW: widgetInstance.minW || 0,
        minH: widgetInstance.minH || 0,
        static: widgetInstance.is_static || false
      };
      return <DashboardWidget 
        widgetInstances={dashboardWidgetInstances}
        widgetInstance={widgetInstance}
        config={widgetInstance.config}
        key={widgetInstance.id}
        data-grid={gridData}
        widgetTypes={widgetTypes}
        onShowWidgetOptions={this.onShowWidgetOptions}
        dashboardId={this.props.dashboardData.id}
        sessionId={this.props.session.id}
        passMap={(m: any) => this.passMap(m)} //Must bind to 'this' using arrow function
        passLayers={(m: any) => this.passLayers(m)} //Must bind to 'this' using arrow function
        configUpdate={(widgetId:string, config:any) => this.onConfigUpdate(widgetId, config)}
        updateWidgetInstances={this.updateWidgetInstances}
        />;
    });
  }
  
  updateWidgetInstances(dashboardWidgetInstances:any, dashboardWidgetInstance:any, widgetTypes: any) {
    
      const dashboard = this.state.dashboard;
      let widgetInstances = dashboard.dashboard_widget_instances;
  
      const widgetInstance = widgetInstances.find((instance:any) => instance.id === dashboardWidgetInstance.id);
      console.log("120321 widgetInstance",  widgetInstance)
      let layout = this.state.layout;
      layout[0].minW = 20;
      layout[0].minH = 20;
      /* could add this as class
        width: calc(100vw - 100px);
        height: calc(100vh - 125px);
        z-index: 10;
      */

      //this.setState({layout});
      if (gridRef) {
        gridRef.setState({ layout: layout }); 
      }
      widgetInstance["minW"] = 20;
      widgetInstance["minH"] = 20;
      widgetInstance["width"] = 20;
      widgetInstance["height"] = 20;
  
     this.setState((previousState:any) => ({
        dashboard: {
          ...previousState.dashboard,
          dashboard_widget_instances: widgetInstances
        }
      }));
  }

  async onHandleAddWidget(widget:any) {
    const { widgetTypes } = this.state;

    if (!widgetTypes) {
      console.error("Could not find dashboard widget typess");
      return;
    }

    const widgetTypeData = widgetTypes.find((element:WidgetType) => element.id === parseInt(widget.type, 10));
    if (!widgetTypeData) {
      console.error("Could not find widget type ", widget.type);
      return;
    }

    const newWidgetInstance = {
      // need to generate id client-side b/c it is used (possibly before widget is saved to db)
      // as an prefix in the s3 session directory.
      id: uuidv4(),
      dashboard_id: this.state.dashboard.id || 0,
      dashboard_widget_type_id: parseInt(widget.type, 10),
      title: widget.title || 'Unknown Title',
      location_x: 0, //(this.state.dashboard.dashboard_widget_instances.length * 2) % (this.state.cols || 12),
      location_y: Infinity, // puts it at the bottom
      width: widgetTypeData.base_width,
      height: widgetTypeData.base_height,
      needsCreate: true,
    };

    let instanceArray = this.state.dashboard.dashboard_widget_instances.concat(newWidgetInstance);

    this.setState((prevState:any) => ({
      // Add a new item. It must have a unique key!
      dashboard: {
        ...prevState.dashboard,
        dashboard_widget_instances: instanceArray
      },
      // Increment the counter to ensure key is always unique.
      newCounter: this.state.newCounter + 1
    }));

    this.sendMessage('Added widget!', 'success', {autoDismissTimeout: 3000});
  }

  onHandleCloseDeleteWidgetModal() {
    this.setState({
      selectedWidget: null,
      showWidgetDeleteModal: false
    });
  }

  showAddWidgetModal() {
    this.setState({
      showAddWidgetModal: true
    });
  }

  onHandleCloseAddWidgetModal() {
    this.setState({
      showAddWidgetModal: false
    });
  }

  onDashboardLoad(dashboardData:any) {
    this.setState({
      dashboard: dashboardData
    });
  }

  sendMessage(msg:string, type:string = 'success', options:object = {}) {
    const { toastManager } = this.props;
    let toastOptions = assign({
      appearance: type,
      autoDismiss: true,
      autoDismissTimeout: 3000,
      placement: 'bottom-center'
    }, options);
    toastManager.add(msg, toastOptions);
  }

  async onAddWidget() {
    this.showAddWidgetModal();
  }

  async touchDashboard(dashboard_id:any) {
    const { client } = this.props;
    const current_time = moment().format("YYYY-MM-DD HH:mm:ss");
    return client.mutate({
      mutation: UPDATE_DASHBOARD,
      variables: {id: dashboard_id, data: {updated_at: current_time}},
      optimisticResponse: null
    });
  }

  async onHandleDeleteWidget(widgetInstance: any) {
    const { layout, dashboard } = this.state;
    const { client } = this.props;
    const widgetInstances = dashboard.dashboard_widget_instances;

    // Find widgetInstance in widget list and remove
    remove(widgetInstances, (instance:any) => {
      return instance.id === widgetInstance.id;
    });

    let isNewWidget = false;

    // Find layout instance
    //const layoutInstance = layout.find((layoutIter:any) => layoutIter.id === widgetInstance.id);
    if (widgetInstance && widgetInstance.id.startsWith('new')) {
      isNewWidget = true;
    }

    // Find widgetInstance in layout list and remove
    remove(layout, (instance:any) => {
      return instance.id === widgetInstance.id;
    });

    if (!isNewWidget) {
      await client.mutate({
        mutation: DELETE_DASHBOARD_WIDGET_INSTANCE,
        variables: {id: widgetInstance.id},
        optimisticResponse: null
      });
    }

    this.setState((prevState:any) => ({
      ...prevState,
      widgetInstances,
      layout,
      selectedWidget: null,
      showWidgetDeleteModal: false
    }));

    this.sendMessage('Deleted widget!', 'success');
  }

  async onSaveDashboard() {
    const { layout, dashboard } = this.state;
    const { client } = this.props;
    const dashboardId = dashboard.id;
    const widgetInstances = dashboard.dashboard_widget_instances;

    console.log("Instance befor: ", widgetInstances);

    if (!layout || layout.length === 0) {
      this.sendMessage("Nothing to save on this dashboard.", "warning");
      return;
    }

    await Promise.all(
      layout.map((layoutData:any) => {
        // Find the widget instance that matches the id
        const savingWidget = widgetInstances.find((element:any) => element.id === layoutData.i);

        // Need to get map so that we can ppulate these parameters
        var transformedCoord = transform(this.state.map.getView().getCenter(),'EPSG:3857','EPSG:4326');
        var widgetConfig = "";
        switch(savingWidget.dashboard_widget_type_id) {
          case 1:
            var layersFromTop = this.state.map.layerList;//this.state.layerList; //JSON.stringify(this.state.map.layerList)
            var jsonConfig = ({
              mapCenter: {
                lat: transformedCoord[1],
                lng: transformedCoord[0],
                zoomLevel: this.state.map.getView().getZoom()
              },
              layersFromTop: layersFromTop  // ** layerList is a custom member of the map  
            });
            console.log(jsonConfig)
            widgetConfig = JSON.stringify(jsonConfig);
            break;
          default:
              widgetConfig = savingWidget.config;
            break;
        }
        // console.log("Widgetisnew", layoutData.i.startsWith('new'));
        console.log("Widgetisnew", savingWidget.needsCreate);
        let dataToSave;
        if (savingWidget && savingWidget.needsCreate) {
          dataToSave = {
            id: savingWidget.id,
            width: layoutData.w,
            height: layoutData.h,
            location_x: layoutData.x,
            location_y: layoutData.y,
            dashboard_id: dashboardId,
            dashboard_widget_type_id: savingWidget.dashboard_widget_type_id,
            title: savingWidget.title,
            config: widgetConfig
          };
          console.log("Saving new data: ", dataToSave);
          return client.mutate({
            mutation: CREATE_DASHBOARD_WIDGET_INSTANCE,
            variables: {data: dataToSave},
            optimisticResponse: null
          }).then((result:any) => {
            savingWidget.needsCreate = false;
          });
        } else {
          dataToSave = {
            id: layoutData.i,
            data: {
              width: layoutData.w,
              height: layoutData.h,
              location_x: layoutData.x,
              location_y: layoutData.y,
              title: savingWidget.title,
              config: widgetConfig
            }
          }
          console.log("Saving old data: ", dataToSave);
          return client.mutate({
            mutation: UPDATE_DASHBOARD_WIDGET_INSTANCE,
            variables: dataToSave,
            optimisticResponse: null
          });
        }
      })
    ).then(() => {

      // Update layout if that was changed
      this.setState((previousState:any) => ({
        ...previousState,
        layout,
        dashboard: {
          ...previousState.dashboard,
          dashboard_widget_instances: widgetInstances
        }
      }));

      this.touchDashboard(dashboardId);
      this.sendMessage('Successfully saved dashboard', 'success', {autoDismissTimeout: 3000});
      console.log("Successfully saved dashboard");
      //this.reloadDashboard();
    }).catch((err:any) => {
      console.error("Could not save the dashboard: ", err);
      this.sendMessage('Could not save the dashboard', 'error', {autoDismissTimeout: 4000});
    });
  }

  async reloadDashboard() {
    // Clear dashboard data
    await this.props.refetchDashboard();
    this.setState({
      dashboard: null
    });
  }

  passMap(payloadObject:any) {
    this.setState({
      map: payloadObject,
    });
  }

  passLayers(payloadObject:any) {
    this.setState({
      layerList: payloadObject,
    });
  }

  onConfigUpdate(widgetInstanceId:string, config:any) {
    console.log("onConfigUpdate() > widgetInstanceId, config", widgetInstanceId, config)
    const dashboard = this.state.dashboard;
    let widgetInstances = dashboard.dashboard_widget_instances;

    const widgetInstance = widgetInstances.find((instance:any) => instance.id === widgetInstanceId);

    widgetInstance.config = config;

    this.setState((previousState:any) => ({
      dashboard: {
        ...previousState.dashboard,
        dashboard_widget_instances: widgetInstances
      }
    }));
  }

  render() {

    console.log("120321 render()")
    const {
      dashboard, showAddWidgetModal, widgetTypes,
      showWidgetDeleteModal, selectedWidget
    } = this.state;

    const { currentUser, isPublic } = this.props;

    if (!dashboard) {
      return <div>Initilizing Dashboard</div>;
    }

    let serverUrl = process.env.REACT_APP_CHATBOT_URL as string;

    return (
      <div className="dashboard_container_parent">
        <SocketComp sessionId={this.props.session.id}>
        <Navigation
          dashboardName={dashboard.name}
          isPublic={isPublic}
          currentUser={currentUser}
          onSaveDashboard={this.onSaveDashboard}
          onAddWidget={this.onAddWidget}
          showDashboardOptions={true}
          userOrgs={this.props.userOrgs}
          refreshAllCredentials={this.props.refreshAllCredentials}
        />
        
        <Container fluid className="dashboard_container">
        <Sidebar
          session={this.props.session} 
          dashboardId={this.props.dashboardId}
          dashboardData={this.props.dashboardData}
          onSaveDashboard={this.onSaveDashboard}
          onAddWidget={this.onAddWidget}
          isPublic={isPublic}
        >   
        </Sidebar>
          {/* useCSSTransforms=false causes performances penalty but
                         react-beautiful-dnd layout breaks w/o it because they
                         don't support transform
                         (performance still seems fine though)
                         https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md#warning-position-fixed
                         https://github.com/STRML/react-grid-layout#grid-layout-props
            */}
          <GridLayout className="layout" cols={24} rowHeight={30} width={3000}
            useCSSTransforms={false}
            onResizeStop={() => window.dispatchEvent(new Event('grid-layout-container-resize'))}
            //draggableHandle=".widgetTitle" // Cannot drag on this element because mouse-event-div obfuscates it
            draggableHandle=".mouse-event-div"
            onLayoutChange={this.onLayoutChange}
            ref={(_gridLayout:any) => { // https://medium.com/@sonalsonu51/resize-grid-item-in-rgl-react-grid-layout-using-a-button-572e45e4d3bc ( https://github.com/sonal-ojha/Resize-Grid-RGL/blob/master/src/App.js#L201 )
                //this.setState({gridRef: _gridLayout})
                gridRef = _gridLayout
              }
            }
            >
            {this.renderWidgetInstances(dashboard.dashboard_widget_instances, widgetTypes)}
          </GridLayout>
        </Container>
        <ModalAddWidget
          show={showAddWidgetModal}
          onHandleClose={this.onHandleCloseAddWidgetModal}
          onAddWidget={this.onHandleAddWidget}
          widgetTypes={widgetTypes}
        />
        <ModalDeleteWidget
          show={showWidgetDeleteModal}
          widgetInstance={selectedWidget}
          onHandleClose={this.onHandleCloseDeleteWidgetModal}
          onDeleteWidget={this.onHandleDeleteWidget}
        />
        {/*<VoiceControl
          dashboardId={this.props.dashboardData.id}
          sessionId={this.props.session.id}
        />
        <Footer
          footerOptions={"none"}
          currentUser={currentUser}
        />*/}
        </SocketComp>
      </div>
    );
  }
}

export default withApollo<any, IDashboardState>(withToastManager(Dashboard));
